import { useEffect, useState } from "react";
import { fetchWatchProvidersInline } from "../api/tmdb";
import { getOttRedirectUrl } from "../utils/OttRedirect";
import { fallbackOttLogos } from "../utils/OttLogos";

function OttModal({ movie, onClose }) {
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    fetchWatchProvidersInline(movie.id).then(setProviders);
  }, [movie.id]);

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>✖</button>

        <h2>{movie.title}</h2>

        <h4>📖 Storyline</h4>
        <p style={{ lineHeight: "1.7" }}>
          {movie.overview || "Storyline not available."}
        </p>

        <h4 style={{ marginTop: "18px" }}>📺 Where to watch</h4>

        <div className="ott-logos">
          {providers.map((p) => {
            const logo =
              p.logo_path
                ? `https://image.tmdb.org/t/p/w45${p.logo_path}`
                : fallbackOttLogos[p.provider_name.toLowerCase()];

            if (!logo) return null;

            return (
              <img
                key={p.provider_id}
                src={logo}
                alt={p.provider_name}
                title={p.provider_name}
                onClick={() =>
                  window.open(
                    getOttRedirectUrl(p.provider_name, movie.title),
                    "_blank"
                  )
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default OttModal;
